import { RefSelectProps, Select } from 'antd';
import React, { forwardRef } from 'react';

export interface ISelectComPesquisaProps extends Omit<React.ComponentProps<typeof Select>, "showSearch" | "optionFilterProp"> {

}

export const SelectComPesquisa = forwardRef<RefSelectProps, ISelectComPesquisaProps>(function (
    {
        filterOption,
        ...props
    },
    ref
) {
    filterOption = filterOption ?? ((input: any, option: any) => (option?.label ?? '').toLocaleLowerCase?.().includes(input.toLocaleLowerCase()));

    return <Select
        {...props}
        className={props.className?? 'select-com-pesquisa'}
        ref={ref}
        showSearch
        optionFilterProp={"children"}
        filterOption={filterOption}
    /> 
});
